import { Navigate, Outlet } from 'react-router';
import { useSubscription } from '../../hooks/subscription/use-subscription';
import { isGuardQuerySettling } from './guard-query-state';

interface IotAddonGuardProps {
  redirectTo?: string;
}

/**
 * Route guard for the IoT add-on. Mirrors DdtAddonGuard's shape but checks
 * `SubscriptionInfo.iotAddonEnabled` instead of a role permission — per-tenant
 * toggle set by platform-admin (`PATCH /admin/tenants/:id/iot-addon`). Gates
 * IoT-only settings (es. Preset alimenti per le sonde) che senza sonde non
 * hanno senso.
 */
export function IotAddonGuard({ redirectTo = '/home' }: IotAddonGuardProps) {
  const { iotAddonEnabled, isPending, fetchStatus } = useSubscription();
  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }
  if (!iotAddonEnabled) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
